<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <h1>Auxiliar de Redação para Alunos Avaliação Fácil para Professores</h1>
                        <p>Trinka AI Avançada não só ajuda os alunos a melhorarem sua escrita, mas também a aprender as melhores
                            práticas de redação acadêmica enquanto escrevem. Os professores se beneficiam de avaliações automatizadas
                            e insights de escrita para feedback focado.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/K12-and-elearning.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>Solução Adequada à Industria para</h2>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="most_suited_point">
                        <ul>
                            <li>Escolas / K-12</li>
                            <li>Faculdades</li>
                            <li>Aplicativos de aprendizagem da língua inglesa</li>
                            <li>Plataformas de e-learning</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Aprovado por Líderes Globais</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/paterson.png" alt="Leaders">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abraham-lincoln.png" alt="Leaders">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanCollegeofGreece.png" alt="Leaders">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/act.png" alt="Leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AguaFriaUnion.png" alt="Leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/almosa.png" alt="Leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amalAcademy.png" alt="Leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/AmericanschoolofDubai.png" alt="Leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/lusaka.png" alt="Leaders">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Auxiliar de Redação de Alta Qualidade para Alunos e Professores</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka ajuda os alunos a criarem melhor e aprenderem os padrões de redação acadêmica. Os professores
                            também recebem relatórios perspicazes sobre a escrita dos alunos.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="writing suggestion" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Sugestões de Redação em Tempo Real para Alunos</h3>
                                    <p>Trinka foi criado exclusivamente para a escrita acadêmica. Ele não apenas corrige erros
                                        gramaticais complexos, mas também melhora o vocabulário, o tom, a sintaxe e muito
                                        mais. Os alunos também podem aprender com as sugestões detalhadas.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Qualityassessment.png" alt="quality assessment" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Índices de Qualidade Personalizáveis para Alunos</h3>
                                    <p>Permite que os alunos obtenham insights em tempo real sobre a qualidade de sua redação
                                        com algoritmos de pontuação personalizáveis. Explicações detalhadas e sugestões em
                                        tempo real ajudam os alunos a aprender e melhorar suas redações.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Automatedfilecorrections.png" alt="file corrections" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Correções de Arquivos Automatizadas e Relatórios de Erros</h3>
                                    <p>Basta fazer upload de documentos do MS Word e obter arquivos editados com alterações
                                        rastreadas em minutos, juntamente com um relatório detalhado de todos os erros. Trinka
                                        torna as avaliações e o feedback mais rápidos e mais fáceis.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="comprehensive" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Análise Abrangente</h3>
                                    <p>Veja como os seus alunos usam Trinka ou aprofunde-se na atividade de cada aluno com análises
                                        ricas para avaliação e feedback eficazes.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc icon" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação de Plágio </h3>
                                    <p>A mais alta qualidade de verificação de plágio, com o algoritmo mais avançado de detecção de semelhança de textos, iThenticate e o maior banco de dados de publicações pagas.</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/FileLevelRestrictions.svg" alt="file level restrictions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Controles em nível de arquivo</h3>
                                    <p>O gerenciamento de acesso é fácil e seguro com os controles granulares do Trinka, para alunos presenciais ou à distância.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy user management" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Fácil Administração</h3>
                                    <p>Trinka permite que você gerencie o acesso, troque licenças ou adicione membros em apenas
                                        alguns segundos e automatiza o resto para você.</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Suporte Dedicado</h3>
                                    <p>Um gerente de sucesso dedicado é designado para apoiar a sua equipe para obter o máximo
                                        de Trinka. Isso inclui uma chamada de integração minuciosa, documentação de ajuda
                                        e orientações em vídeo.
                                    </p>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Empresa Trinka para K-12 e E-learning
                    </h2>
                    <div class="HeadingSubLine"></div>
                    <p>Descubra o verdadeiro poder de Trinka para plataformas educacionais por meio de recursos personalizados.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Acompanhando o Progresso do Aprendizado</h4>
                                <p>Avalie e acompanhe a melhoria da redação de cada aluno ao longo do tempo usando a avaliação
                                    com percepções detalhadas.
                                </p>
                                <ul>
                                    <li>Pontuação de qualidade de escrita</li>
                                    <li>Relatório de qualidade inteligente da categoria de erro</li>
                                    <li>Correções e sugestões para assistência ao aluno</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Identificando Lacunas de Aprendizagem</h4>
                                <p>Identifique as necessidades individuais do aluno com insights sobre os tipos e frequências
                                    de erros cometidos e uma pontuação personalizável.</p>
                                <ul>
                                    <li>Algoritmo de pontuação de qualidade automatizado personalizável</li>
                                    <li>Resumo dos erros por categoria</li>
                                    <li>Correções rastreadas para avaliação e feedback </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="all_usecases_item all_usecases_item_last">
                                <h4>Suporte de Aprendizagem em Tempo Real</h4>
                                <p>Trinka AI avalia a redação em tempo real e oferece correções e sugestões instantaneamente
                                    para ajudar os alunos a identificarem melhorias e aprenderem melhores práticas de escrita.</p>
                                <ul>
                                    <li>Oportunidades de aprendizagem no contexto</li>
                                    <li>Correção com explicações detalhadas</li>
                                    <li>Índices de qualidade interativos</li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>Assistência para Redação Onde Quer que Seus Alunos Escrevam</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>Trinka pode ser acessado em várias plataformas, permitindo que seus alunos se beneficiem de uma poderosa
                    assistência de redação onde quer que escrevam - do navegador ao Microsoft Word.</p>
            </div>
        </div>
        <div class="row">

            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Cloud Editor</h3>


                    <p>
                        Use todo o potencial de Trinka em qualquer lugar, com o aplicativo seguro baseado na web.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Suplemento MS Word</h3>
                    <p>
                        Aumente a produtividade de suas equipes com sugestões de redação fornecidas no MS Word.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>Plug-ins no Navegador</h3>
                    <p>
                        Assistência de redação em tempo real em qualquer site da Web por meio de plug-ins para todos os seus navegadores favoritos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>Preços Personalizados que Funcionam para Você</h2>
                </div>
                <p>Trinka oferece preços flexíveis para usuário ou baseados no uso para atender às suas necessidades exclusivas.
                    <br>Troque de usuário e aplique restrições de uso em tempo real, sem nenhum custo extra.
                    <br>Trabalharemos com você para criar um contrato personalizado sem complicações e uma opção de pagamento
                    único por meio de pedido de compra / fatura.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="about ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Permita que os alunos escrevam melhor com o Trinka</p>
    <button  data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">Obtenha uma cotação</button>
</div>

<app-enterprise-modal></app-enterprise-modal>